import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { Button, Checkbox, Dropdown, Form, Notification, Toast } from '@douyinfe/semi-ui';
import { useRouter } from 'next/router';
import useRequest from '@/utils/useRequest';
import { IndexContext } from '@/stores';
import { debounce } from 'lodash';
import { PRODDOMAIN } from '@/utils';
import classNames from 'classnames';

interface IProps {
}

export default ({ }) => {
  const router = useRouter()
  const request = useRequest()
  const phoneRef = useRef<any>()
  const forgetRef = useRef<any>()
  const pswRef = useRef<any>()
  const vcode_key = useRef<number>(new Date().getTime())
  const [reload, setReload] = useState<any>(`${PRODDOMAIN}/visitor/ajax/get_verify?key=${vcode_key}`)
  const [isPhone, setIsPhone] = useState<any>(true)
  const checkbox = useRef<any>()
  const { setIsHeadFoot, setLang } = useContext(IndexContext);
  const [countdown, setCountdown] = useState(0);
  const timerRef = useRef<any>();
  const [isForget, setIsForget] = useState<any>(false)


  const btnClick = useCallback(async () => {

    const { mobile, sms_code } = phoneRef.current?.getFormState()?.values
    // const { user_type } = pswRef.current?.getFormState()?.values
    console.log(isPhone, phoneRef.current?.getFormState().values);

    phoneRef.current.validate().then(async () => {
      const params = isPhone ? {
        mobile,
        sms_code
      } : {
        ...phoneRef.current?.getFormState().values
      }
      const { data } = await request.post(isPhone ? '/visitor/mobile_login' : "/visitor/do_login", params)
      if (data?.code == 1) {
        // let user = data?.data?.payload || {}
        // localStorage.setItem('token', window.btoa('123'))
        document.cookie = `v_token=${data?.data?.jwt}; Expires=${new Date(data?.data?.payload?.expire * 1000).toUTCString()}; Path=/; Secure; SameSite=Lax`;
        localStorage.setItem('user', window.btoa(JSON.stringify(data?.data?.payload)))
        const to = router.query.to as string
        router.push(to || 'https://visitor.organic-festa.com/index')
      } else {
        Toast.error(data?.msg)
      }
    }).catch((err: any) => {
      console.log(err);

      Toast.error(Object.values(err).join(' '))
    })

  }, [isPhone, router])

  const forget = useCallback(async () => {

    const { sms_code, user_type } = forgetRef.current?.getFormState().values
    console.log(forgetRef.current, forgetRef.current?.getFormState().values);

    forgetRef.current.validate().then(async () => {
      const { data } = await request.post("/visitor/forget_pwd", {
        ...forgetRef.current?.getFormState().values,
        vcode: sms_code
      }, {
        headers: {
          ['x-lang']: user_type == 1 ? 'cn' : 'en'
        }
      })
      if (data?.code == 1) {
        Toast.success("修改成功")
        setIsForget(false)
      } else {
        Toast.error(data?.msg)
      }
    }).catch((err: any) => {
      Toast.error(Object.values(err).join(' '))
    })

  }, [])

  const sendCaptcha = useCallback(async () => {
    const { mobile, email, vcode, user_type } = forgetRef.current.getFormState().values
    console.log(mobile, email, vcode, user_type);


    if (user_type == 1 && !/^1[3-9]\d{9}$/.test(mobile)) {
      Toast.error('请输入有效手机号')
      return
    }

    if (user_type == 2 && !/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
      Toast.error('请输入有效邮箱')
      return
    }

    if (!vcode) {
      Toast.error('请输入图形验证码')
      return
    }
    try {
      const { data: test } = await request.post('/visitor/check_account', {
        account: user_type == 1 ? mobile : email
      })
      if (test?.code != 1) {
        Toast.error(test?.msg)
        return
      }
      const parmas = user_type == 1 ? {
        mobile
      } : {
        email
      }
      const { data } = await request.post(user_type == 1 ? '/visitor/ajax/send_sms_code' : '/visitor/ajax/send_email_code', {
        ...parmas, vcode,
        vcode_key: vcode_key.current
      })
      if (data?.code != 1) {
        vcode_key.current = new Date().getTime()
        setReload(`${PRODDOMAIN}/visitor/ajax/get_verify?key=${vcode_key.current}`)
        Toast.error(data?.msg)
        return
      }
      // 开始倒计时
      setCountdown(60);
    } catch (error) {
      console.error('验证码发送失败:', error);
      setCountdown(0); // 出错时重置状态
    }
  }, []);

  const sendLoginCaptcha = useCallback(async () => {
    const { mobile, vcode } = phoneRef.current.getFormState().values
    if (!/^1[3-9]\d{9}$/.test(mobile)) {
      Toast.error('请输入有效手机号')
      return
    }

    if (!vcode) {
      Toast.error('请输入图形验证码')
      return
    }
    try {
      const { data: test } = await request.post('/visitor/check_account', {
        account: mobile
      })
      if (test?.code != 1) {
        Toast.error(test?.msg)
        return
      }
      const { data } = await request.post('/visitor/ajax/send_sms_code', {
        mobile, vcode,
        vcode_key: vcode_key.current
      })
      if (data?.code != 1) {
        vcode_key.current = new Date().getTime()
        setReload(`${PRODDOMAIN}/visitor/ajax/get_verify?key=${vcode_key.current}`)
        Toast.error(data?.msg)
        return
      }
      // 开始倒计时
      setCountdown(60);
    } catch (error) {
      console.error('验证码发送失败:', error);
      setCountdown(0); // 出错时重置状态
    }
  }, []);

  useEffect(() => {
    setIsHeadFoot(false)
    // router.push(jwt ? '/index' : '/login')
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
      setIsHeadFoot(true)
    }
  }, [])

  useEffect(() => {
    if (countdown > 0) {
      timerRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timerRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timerRef.current);
  }, [countdown]);

  return (
    <div className={styles.container}>
      <div className={styles.rightBtns}>
        <Dropdown
          style={{ width: '175px' }}
          render={
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setLang('cn')}>中文</Dropdown.Item>
              <Dropdown.Item onClick={() => setLang('en')}>English</Dropdown.Item>
            </Dropdown.Menu>
          }
        >
          <div className={styles.langBtn}>
            <span>语言：</span>中文
          </div>
        </Dropdown>
        {isForget ?
          <div className={styles.toHome} onClick={() => setIsForget(false)}>返回登录</div>
          : <a className={styles.toHome} href="https://www.organic-festa.com/">返回首页</a>
        }      </div>
      <div className={styles.left}>
        <img className={styles.logo} src="/image/logo-white.png" alt="" />
        <img src="/image/login-title.png" alt="" />
      </div>
      <div className={styles.right}>
        {isForget ?
          <div>
            <h2>忘记密码</h2>
            <Form
              getFormApi={(formApi: any) => forgetRef.current = formApi}
              labelWidth={0}
            >
              {
                (({ formState, values, formApi }) => (
                  <>
                    <div className={styles.form}>
                      <Form.RadioGroup
                        options={[{ label: '中国大陆', value: '1' }, { label: '非中国大陆', value: '2' }]}
                        style={{ gap: '40px', marginBottom: '-20px' }}
                        field="user_type"
                        noLabel
                        direction="horizontal"
                        defaultValue={{ value: '1' }}
                        initValue={'1'}
                      />
                      <Form.Input
                        field={formApi.getValue('user_type') == '1' ? 'mobile' : 'email'}
                        placeholder={formApi.getValue('user_type') == '1' ? '输入手机号码' : '请输入邮箱'}
                        noLabel
                        noErrorMessage
                        rules={[
                          { required: true, message: formApi.getValue('user_type') == '1' ? '输入手机号码' : '请输入邮箱' },
                        ]}
                      />
                      <div className={styles.vcode}>
                        <Form.Input
                          field="vcode"
                          placeholder='图片验证码'
                          noLabel
                          noErrorMessage
                          rules={[
                            { required: true, message: '请输入图片验证码' },
                          ]}
                        />
                        {reload && <img src={reload} onClick={() => {
                          vcode_key.current = new Date().getTime()
                          setReload(`${PRODDOMAIN}/visitor/ajax/get_verify?key=${vcode_key.current}`)
                        }} alt="" />}
                      </div>
                      <div className={styles.psw}>
                        <Form.Input
                          field="sms_code"
                          placeholder='请输入验证码'
                          noLabel
                          noErrorMessage
                          autoComplete='off'
                          rules={[
                            { required: true, message: '请输入验证码' },
                          ]}
                        />
                        <Button
                          onClick={debounce(() => sendCaptcha(), 500)}
                          disabled={countdown > 0}
                        >{countdown > 0 ? `${countdown}秒后可重发` : '获取验证码'}</Button>
                      </div>
                      <Form.Input
                        field="password"
                        placeholder='请输入新密码'
                        noLabel
                        type='password'
                        noErrorMessage
                        autoComplete='off'
                        rules={[
                          { required: true, message: '请输入新密码' },
                          {
                            pattern: /^.{6,16}$/,
                            message: '密码需6-16位'
                          }

                        ]}
                      />
                      <Form.Input
                        field="verify_password"
                        placeholder='请输入确认新密码'
                        noLabel
                        type='password'
                        noErrorMessage
                        autoComplete='off'
                        rules={[
                          { required: true, message: '请输入确认新密码' },
                          {
                            pattern: /^.{6,16}$/,
                            message: '密码需6-16位'
                          }
                        ]}
                      />
                    </div>
                    <div className={styles.login} onClick={debounce(() => forget(), 500)}>保存</div>
                  </>
                ))}

            </Form>
          </div>
          : <div>
            <h2>观众中心</h2>
            <p>欢迎登录 <span>亚洲有机产业展览会</span> 观众中心！</p>
            <div className={styles.tabs}>
              <span className={classNames({ [styles.active]: isPhone })} onClick={() => setIsPhone(true)}>手机登录</span>
              <span className={classNames({ [styles.active]: !isPhone })} onClick={() => setIsPhone(false)}>账号登录</span>
            </div>
            <Form
              getFormApi={(formApi: any) => phoneRef.current = formApi}
              labelWidth={0}
            >
              {
                (({ formState, values, formApi }) => (
                  <div className={styles.form}>
                    {
                      isPhone ?
                        <>
                          <div className={styles.account}>
                            <Form.Input
                              field="mobile"
                              placeholder='输入手机号码'
                              noLabel
                              noErrorMessage
                              rules={[
                                { required: true, message: '请输入手机号码' },
                                {
                                  pattern: /^1[3-9]\d{9}$/,
                                  message: '请输入正确的手机号码'
                                }
                              ]}
                            />
                          </div>
                          <div className={styles.vcode}>
                            <Form.Input
                              field="vcode"
                              placeholder='图形验证码'
                              noLabel
                              noErrorMessage
                              rules={[
                                { required: true, message: '请输入图形验证码' },
                              ]}
                            />
                            {reload && <img src={reload} onClick={() => {
                              vcode_key.current = new Date().getTime()
                              setReload(`${PRODDOMAIN}/visitor/ajax/get_verify?key=${vcode_key.current}`)
                            }} alt="" />}
                          </div>
                          <div className={styles.psw}>
                            <Form.Input
                              field="sms_code"
                              placeholder='请输入验证码'
                              noLabel
                              noErrorMessage
                              autoComplete='off'
                              rules={[
                                { required: true, message: '请输入验证码' },
                              ]}
                            />
                            <Button
                              onClick={debounce(() => sendLoginCaptcha(), 500)}
                              disabled={countdown > 0}
                            >{countdown > 0 ? `${countdown}秒后可重发` : '获取验证码'}</Button>
                          </div>
                        </>
                        :
                        <>
                          <Form.RadioGroup
                            options={[{ label: '中国大陆', value: '1' }, { label: '非中国大陆', value: '2' }]}
                            style={{ gap: '40px', marginBottom: '-20px' }}
                            field="user_type"
                            noLabel
                            direction="horizontal"
                            defaultValue={{ value: '1' }}
                            initValue={'1'}
                          />
                          <div className={styles.account}>
                            <Form.Input
                              field="account"
                              placeholder={formApi.getValue('user_type') == '1' ? '输入手机号码' : '请输入邮箱'}
                              noLabel
                              noErrorMessage
                              rules={[
                                { required: true, message: formApi.getValue('user_type') == '1' ? '输入手机号码' : '请输入邮箱' },
                              ]}
                            />
                          </div>
                          <div>
                            <Form.Input
                              field="pwd"
                              placeholder='请输入密码'
                              noLabel
                              type='password'
                              noErrorMessage
                              rules={[
                                { required: true, message: '请输入密码' },
                              ]}
                            />
                          </div>
                          <p className={styles.forget} onClick={() => setIsForget(true)}>忘记密码?</p>
                        </>
                    }

                  </div>
                ))}

            </Form>

            <div className={styles.login} onClick={debounce(() => btnClick(), 500)}>立即登录</div>
            <a href="https://visitor.organic-festa.com/register">未有账号？立即注册</a>
          </div>}
      </div>
      <style jsx global>
        {
          `
            .semi-form-field{
              // padding:0;
            }
            .semi-input-wrapper{
              border: none !important;
              background:#f3f5f9 !important;
              height:54px;              
            }
            .semi-input{
              height:100%;
              padding-right:142px;
              padding-left:20px;
            }
            .semi-input-wrapper:hover {
              border: none;
              background:#f3f5f9;
            }
          `
        }
      </style>
    </div>
  );
};
